import { MapPin, Clock, Phone, Mail } from "lucide-react";
import { Reveal } from "./Reveal";
import { SITE, CITIES } from "@/lib/site";

export const ServiceArea = () => (
  <section id="service-area" className="relative py-24 lg:py-36 px-6 lg:px-12 overflow-hidden" data-testid="service-area-section">
    <div className="max-w-[1400px] mx-auto">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.4em] text-orange-500 mb-4">Coverage</p>
        <h2 className="font-display uppercase leading-[0.85] text-[clamp(3rem,9vw,8rem)]">
          <span className="text-white block">45-Mile Radius</span>
          <span className="text-outline block">Coverage Zone</span>
        </h2>
      </Reveal>

      <div className="mt-14 grid gap-6 lg:grid-cols-5">
        <Reveal className="lg:col-span-3">
          <div className="h-full bg-[#14171f] border border-white/10 p-8 lg:p-10" data-testid="service-area-hub-card">
            <div className="flex items-center gap-3">
              <span className="bg-orange-600 p-2.5 text-[#0c0e12]">
                <MapPin size={20} strokeWidth={2.5} />
              </span>
              <div>
                <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-slate-400">Central Hub</p>
                <p className="font-display text-3xl text-white uppercase tracking-wide">{SITE.hub}</p>
              </div>
            </div>
            <p className="mt-6 text-sm text-slate-400 leading-relaxed max-w-md">
              Every job within 45 miles of Lawrenceville gets the same crew, the same standard, and
              the same straight answer on price. If your town is on the list, you are in the zone.
            </p>
            <div className="mt-8 flex flex-wrap gap-2" data-testid="service-area-cities">
              {CITIES.map((city) => (
                <span
                  key={city}
                  className="font-mono text-[11px] uppercase tracking-[0.15em] px-3 py-1.5 border border-white/15 text-slate-300 hover:border-orange-500 hover:text-orange-500 transition-colors duration-200"
                >
                  {city}
                </span>
              ))}
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.1} className="lg:col-span-2">
          <div className="h-full flex flex-col gap-6">
            <div className="flex-1 bg-[#14171f] border border-white/10 p-8" data-testid="service-area-hours-card">
              <div className="flex items-center gap-3">
                <Clock size={20} className="text-orange-500" />
                <h3 className="font-display text-2xl text-white uppercase tracking-wide">Working Hours</h3>
              </div>
              <p className="mt-4 font-mono text-sm text-slate-200 uppercase tracking-wider">{SITE.hours}</p>
              <p className="mt-1 font-mono text-xs text-slate-500 uppercase tracking-wider">{SITE.hoursNote}</p>
            </div>
            <div className="flex-1 bg-orange-600 p-8 text-[#0c0e12]" data-testid="service-area-contact-card">
              <h3 className="font-display text-2xl uppercase tracking-wide">Inside the zone? Talk to us.</h3>
              <a href={SITE.phoneHref} data-testid="service-area-phone" className="mt-4 flex items-center gap-3 font-mono text-sm font-bold uppercase tracking-wider hover:underline">
                <Phone size={16} strokeWidth={2.5} /> {SITE.phone}
              </a>
              <a href={SITE.emailHref} data-testid="service-area-email" className="mt-2 flex items-center gap-3 font-mono text-sm font-bold uppercase tracking-wider hover:underline break-all">
                <Mail size={16} strokeWidth={2.5} /> {SITE.email}
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
